<template>
  <!-- Première cellule vide pour la colonne fixe -->
  <div v-if="state.selectedView.name != 'Semaine'" class="p-0 bg-white" :style="{ gridColumn: `span 1` }">
    <select 
      class="bg-[#1E1017] text-white rounded-2xl rounded-br-none p-1 pl-2 w-full truncate h-8 select-none cursor-pointer hover:bg-[#E8535D]"
      v-model="state.selectedRows"
    >
      <option v-for="row in state.rows" :key="row.name" :value="row">{{ row.name }}</option>
    </select>
  </div>
  <div v-else class="p-2 bg-white" :style="{ gridColumn: `span 1` }"></div>

  <!-- Pour chaque jour, pour chaque heure générée, on affichera l'heure avec un fond conditionnel -->
  <template v-for="(week, wIndex) in dateArrays.weeks" :key="'week-' + wIndex">
    <div 
      @click="go_to(week.startDate)"
      :class="[
        'bg-[#1E1017] text-white p-1 select-none cursor-pointer hover:bg-[#E8535D]',
        { 
          'truncate': dateArrays.weeks.length <= 7,
          'ml-1': wIndex !== 0 && (state.selectedView.name == 'Jour' || state.selectedView.name == 'Semaine'),
          'rounded-2xl mb-1': state.selectedView.name == 'Jour' || state.selectedView.name == 'Semaine',
          'rounded-t-xl': state.selectedView.name !== 'Jour' && state.selectedView.name !== 'Semaine' 
        }
      ]"
      :style="{ gridColumn: `span ${weekSpan(week)}` }"
    >
      <div class="flex justify-between">
        <span>{{ getStartDay(week) }}</span>
        <span>{{ formatWeek(week) }}</span>
        <span></span>
      </div>
    </div>
  </template>
</template>

<script>

import { inject } from 'vue';

export default{
  props:{
    slotsLength: Number,
  },
  setup(){
    const dateArrays = inject('dateArrays');
    const state = inject('state');
    const checkForViewChange = inject('checkForViewChange');
    return { dateArrays, state, checkForViewChange };
  },
  methods:{
    weekSpan(week){
      return (this.slotsLength * week.days);
    },
    getStartDay(week){
      if(['Jour', 'Semaine', 'Année'].includes(this.state.selectedView.name)) return '';

      return new Date(week.startDate).getDate();
    },
    formatWeek(week) {
      let formatted;
      if (['Année'].includes(this.state.selectedView.name)) {
        formatted = week.number;
      }
      else if(['Semestre', 'Trimestre'].includes(this.state.selectedView.name)){
        return '';
      }
      else if (this.dateArrays.weeks.length > 7) {
        formatted = "S." + week.number;
      }
      else {
        formatted = "Semaine " + week.number;
      }
      return formatted;
    },
    go_to(date){
      this.state.startDate = new Date(date);
      this.state.endDate = new Date(new Date(date).setDate(new Date(date).getDate() + 7));
      this.checkForViewChange()
    }
  }
}

</script>